import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export const stateKey: PluginKey = new PluginKey('tasksAndDecisionsPlugin');
